import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  section: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  row: {
    flexDirection: "row",
    fontSize: 9,
  },
  title: {
    width: "85%",
    textAlign: "left",
    fontWeight: "bold"
  },
  author: {
    width: "100%",
    textAlign: "left",
    fontStyle: "italic"
  },
  synopsis: {
    width: "100%",
    textAlign: "justify",
    paddingBottom: 3
  },
  pageDetails: {
    width: "10%",
    textAlign: "left",
  },
  yearDetails: {
    width: "15%",
    textAlign: "left",
  },
  placeDetails: {
    width: "15%",
    textAlign: "left",
  },
  coverDetails: {
    width: "25%",
    textAlign: "left",
  },
  volumeDetails: {
    width: "15%",
    textAlign: "left",
  },
  bookSize: {
    width: "20%",
    textAlign: "right",
  },
});

const replaceText = (text) => {
  return text ? text.replace(/1\/4/g, "¼").replace(/1\/2/g, "½").replace(/3\/4/g, "¾") : text;
};

export default ({ book }) => {

  return (
    <View style={styles.section}>
      <View style={styles.row}>
        <Text style={styles.title}>{book.name}</Text>
      </View>
      <View style={styles.row}>
        <Text style={styles.author}>{book.Author.name}</Text>
      </View>
      <View style={styles.row}>
        <Text style={styles.synopsis}>{book.synopsis}</Text>
      </View>
      <View style={styles.row}>
        <Text style={styles.pageDetails}>{book.numberOfPages && `Pg ${book.numberOfPages}`}</Text>
        <Text style={styles.yearDetails}>{book.yearOfPublication && `Year ${book.yearOfPublication}`}</Text>
        <Text style={styles.placeDetails}>{book.placeOfPrinting}</Text>
        <Text style={styles.volumeDetails}>{book.volumeDetails && `Vol ${book.volumeDetails}`}</Text>
        <Text style={styles.coverDetails}>{book.coverDetails && `Cover ${book.coverDetails}`}</Text>
        <Text style={styles.bookSize}>{book.bookSize && `Size ${replaceText(book.bookSize)}`}</Text>
      </View>
    </View>
  );
}